import { Box, Skeleton } from '@mui/material';
import type { ProductCard as ProductCardType } from '@repo/supergraph/roundup/base/types';
import React, { RefObject } from 'react';

import { ProductListData } from '@repo/ui/LinkedDataJson/ProductListData';
import { shallow } from 'zustand/shallow';
import {
  useGetOffersFilterOffers,
  useOffersFilterStore,
} from '../../../../components/OffersFilter/store';
import { ProductCard } from '../../ProductCard';
import { EmptyState } from './EmptyState';
import { SeeMoreRatesButton } from './SeeMoreRatesButton';

const MemoizedProductCardContainer = React.memo(
  ({
    isLoading,
    productCard,
    index,
    isCompareEnabled,
  }: {
    isLoading: boolean;
    productCard: ProductCardType;
    index: number;
    isCompareEnabled: boolean;
  }) => (
    <Box
      sx={{ width: '100%', flexDirection: 'column' }}
      data-testid={`${productCard.marketplaceEntity.id}-filtered`}
    >
      {!isLoading ? (
        <ProductCard productCard={productCard} index={index} isCompareEnabled={isCompareEnabled} />
      ) : (
        <Skeleton variant="rectangular" height="260px" width="100%" animation={false} />
      )}
    </Box>
  ),
);

export const OfferList = ({
  pageUrl,
  offerListRef,
  analyticsProps,
  isCompareEnabled = false,
}: {
  analyticsProps: {
    actionSection: string;
    pageIdentifier: string;
  };
  pageUrl: string;
  offerListRef: RefObject<HTMLDivElement | null>;
  isCompareEnabled?: boolean;
}) => {
  const allOffers = useGetOffersFilterOffers();
  const [visibleOffersCount, setVisibleOffersCount] = React.useState<number>(10);
  const isLoading = useOffersFilterStore(state => state.isLoading, shallow);
  const visibleOffers = allOffers.slice(0, visibleOffersCount);

  return (
    <>
      <ProductListData
        title="cdrates-linked-data"
        id="cdrates-linked-data"
        offers={visibleOffers}
        url={pageUrl}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, pt: '1rem' }} ref={offerListRef}>
        {visibleOffers.length === 0 && <EmptyState />}
        {visibleOffers.map((productCard, index) => {
          return (
            <MemoizedProductCardContainer
              key={`${index}-${productCard.marketplaceEntity.id}-filtered`}
              productCard={productCard}
              index={index}
              isLoading={isLoading}
              isCompareEnabled={isCompareEnabled}
            />
          );
        })}
      </Box>
      {visibleOffers.length !== 0 && (
        <SeeMoreRatesButton
          visibleOffersCount={visibleOffersCount}
          onClick={() => setVisibleOffersCount(visibleOffersCount + 10)}
          analyticsProps={analyticsProps}
        />
      )}
    </>
  );
};
